import {
	SearchPatientAction,
	SearchPatientsState,
	SEARCH_PATIENTS_ACTION_TYPES,
} from '../../../types/patients'
import { PatientDataRequestModel } from '../../../types/searchPatients'

const initialState: SearchPatientsState = {
	appliersFilters: [],
	requestParamsFilter: new PatientDataRequestModel(),
	selectedPatients: [],
	patientsDataArray: [],
	filteredPatientsCount: 0,
	totalPatientsCount: undefined,
	selectedAssignPatients: [],
	isHoldSelectedPatients: true,
}

export default (
	state = initialState,
	action: SearchPatientAction
): SearchPatientsState => {
	switch (action.type) {
		case SEARCH_PATIENTS_ACTION_TYPES.APPLY_FILTERS: {
			return {
				...state,
				appliersFilters: action.payload,
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.REMOVE_FILTER_FROM_APPLY_FILTERS: {
			return {
				...state,
				appliersFilters: [...state.appliersFilters].filter(
					child => child.key !== action.payload.key
				),
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.CHANGE_PATIENT_DATA_REQUEST_FILTER: {
			return {
				...state,
				requestParamsFilter: {
					...state.requestParamsFilter,
					[action.key]: action.value,
				},
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.SET_SELECTED_PATIENTS: {
			return {
				...state,
				selectedPatients: action.payload,
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.GET_ALL_PATIENTS: {
			return {
				...state,
				patientsDataArray: action.payload,
				filteredPatientsCount: action.filteredPatientsCount,
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.SET_TOTAL_COUNT_PATIENTS: {
			return {
				...state,
				totalPatientsCount: action.payload,
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.SELECTED_ASSIGN_PATIENTS: {
			return {
				...state,
				selectedAssignPatients: action.payload,
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.IS_HOLD_SELECTED_PATIENTS: {
			return {
				...state,
				isHoldSelectedPatients: action.payload,
			}
		}
		case SEARCH_PATIENTS_ACTION_TYPES.RESET: {
			return initialState
		}
		default: {
			return state
		}
	}
}
